<div class="flex flex-col min-h-screen p-3 sm:p-6" *transloco="let t">
  <!-- Título da Página com Contador (US-04) -->
  <div class="mb-4 sm:mb-8 flex items-center justify-between gap-3">
    <h4 class="text-left text-lg sm:text-xl font-bold">{{ t('labels.title') }}</h4>

    <span *ngIf="todayPrintCount !== null" aria-live="polite"
          class="inline-flex items-center gap-2 px-3 py-1 text-xs sm:text-sm font-medium bg-green-50 text-green-700 border border-green-200">
      {{ t('labels.todayCount', { count: todayPrintCount }) }}
    </span>
  </div>

  <!-- Caixa de Input de ID do Pedido -->
  <div class="mb-4">
    <div class="flex gap-2">
      <input #orderIdInput type="text" [disabled]="loading || printing || isProcessingQRCode" id="orderId" [(ngModel)]="orderId"
             (keydown.enter)="print()"
             class="flex-1 px-3 sm:px-4 py-2 text-sm sm:text-base border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500"
             [placeholder]="t('labels.orderIdPlaceholder')">
      <button type="button"
              (click)="toggleQRCodeScanner()"
              [disabled]="loading || printing"
              [class.bg-green-600]="isScanning"
              [class.bg-blue-600]="!isScanning"
              [class.hover:bg-green-700]="isScanning"
              [class.hover:bg-blue-700]="!isScanning"
              class="px-4 py-2 text-white font-medium transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center gap-2">
        <svg *ngIf="!isScanning" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
        </svg>
        <svg *ngIf="isScanning" class="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
        </svg>
        <span class="hidden sm:inline">{{ isScanning ? t('labels.stopCamera') : t('labels.useCamera') }}</span>
      </button>
    </div>

    <!-- Área do Scanner QR Code -->
    <div *ngIf="isScanning" class="mt-4 flex justify-center">
      <div id="qr-reader" class="w-full max-w-md overflow-hidden border-2 border-blue-500"></div>
    </div>

    <!-- Mensagem de erro de permissão -->
    <div *ngIf="cameraPermissionDenied" class="mt-2 p-3 bg-red-50">
      <p class="text-sm text-red-600">
        {{ t('labels.cameraDenied') }}
      </p>
    </div>
  </div>

  <!-- Modo Scanner Mobile - Minimalista -->
  <div class="mb-4 sm:mb-8">
    <div class="bg-blue-50 p-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <div *ngIf="!isMobileScannerModeActive" class="text-sm text-gray-600">
            {{ t('labels.mobileScanner') }}
          </div>
          <div *ngIf="isMobileScannerModeActive && !scannerSessionInfo?.isConnected" class="flex items-center gap-2 text-amber-600">
            <svg class="w-4 h-4 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
            </svg>
            <span class="text-sm font-medium truncate">{{ t('labels.waitingMobile') }}</span>
            <button type="button"
                    (click)="showQrCodeModal = true"
                    class="text-xs text-blue-600 hover:text-blue-800 underline ml-2">
              {{ t('labels.viewQrCode') }}
            </button>
          </div>
          <div *ngIf="isMobileScannerModeActive && scannerSessionInfo?.isConnected" class="flex items-center gap-2 text-green-600">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
            </svg>
            <span class="text-sm font-medium truncate">{{ scannerSessionInfo?.deviceLabel }}</span>
            <button
              type="button"
              (click)="revokePairedDevice()"
              class="text-xs text-red-600 hover:text-red-800 underline ml-1 whitespace-nowrap">
              {{ t('labels.revokeDevice') }}
            </button>
          </div>
        </div>
        <button type="button"
                (click)="isMobileScannerModeActive ? deactivateMobileScannerMode() : activateMobileScannerMode()"
                [disabled]="loading || printing"
                [class.bg-red-600]="isMobileScannerModeActive"
                [class.bg-blue-600]="!isMobileScannerModeActive"
                [class.hover:bg-red-700]="isMobileScannerModeActive"
                [class.hover:bg-blue-700]="!isMobileScannerModeActive"
                class="px-3 py-1.5 text-white text-sm font-medium transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap flex-shrink-0 ml-2">
          {{ isMobileScannerModeActive ? t('labels.deactivate') : t('labels.activate') }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal do QR Code -->
  <div *ngIf="showQrCodeModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" (click)="closeQrCodeModal()">
    <div class="bg-white p-6 max-w-md w-full max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-semibold text-gray-800">{{ t('labels.connectMobile') }}</h3>
        <button type="button"
                (click)="closeQrCodeModal()"
                class="text-gray-400 hover:text-gray-600 transition-colors">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <p class="text-sm text-gray-600 mb-4 text-center">
        {{ t('labels.scanToConnect') }}
      </p>

      <div class="flex justify-center mb-3">
        <img *ngIf="qrCodeImageUrl && pairingSecondsLeft > 0" [src]="qrCodeImageUrl" [alt]="t('labels.sessionQrAlt')" class="p-2 bg-white max-w-xs">
        <div *ngIf="pairingSecondsLeft <= 0" class="p-6 bg-gray-100 text-center max-w-xs">
          <p class="text-sm text-gray-600">{{ t('labels.pairingCodeExpired') }}</p>
        </div>
      </div>

      <!-- Código da estação: o operador confere nas duas telas -->
      <p class="text-center mb-2">
        <span class="text-xs text-gray-500 block">{{ t('labels.stationCode') }}</span>
        <span class="text-2xl font-mono font-bold tracking-widest text-gray-800">{{ scannerSessionInfo?.stationCode }}</span>
      </p>

      <p *ngIf="pairingSecondsLeft > 0" class="text-xs text-gray-500 text-center mb-3">
        {{ t('labels.pairingCodeExpiresIn', { seconds: pairingSecondsLeft }) }}
      </p>

      <!-- Confirmação: o operador digita o que apareceu no celular -->
      <div class="border-t border-gray-200 pt-4 mb-4">
        <p *ngIf="pendingDeviceLabel" class="text-xs text-amber-700 bg-amber-50 border border-amber-200 p-2 mb-3">
          {{ t('labels.deviceWaiting', { device: pendingDeviceLabel }) }}
        </p>

        <label class="text-sm font-medium text-gray-700 block mb-2">{{ t('labels.typeConfirmationCode') }}</label>
        <div class="flex gap-2">
          <input
            type="text"
            inputmode="numeric"
            maxlength="6"
            [(ngModel)]="confirmationInput"
            (keyup.enter)="confirmPairing()"
            [placeholder]="t('labels.confirmationPlaceholder')"
            class="flex-1 border border-gray-300 p-2 font-mono text-lg tracking-widest text-center">
          <button
            type="button"
            (click)="confirmPairing()"
            [disabled]="confirmingPairing || !confirmationInput"
            class="px-4 py-2 bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap">
            {{ t('labels.confirmPairing') }}
          </button>
        </div>
        <p class="text-xs text-gray-500 mt-2">{{ t('labels.confirmationHint') }}</p>
      </div>

      <div class="flex justify-center mb-4">
        <button
          type="button"
          (click)="regeneratePairingCode()"
          class="px-3 py-1.5 border border-blue-600 text-blue-600 text-sm font-medium hover:bg-blue-50 transition-colors">
          {{ t('labels.newPairingCode') }}
        </button>
      </div>

      <!-- Instruções de Como Usar -->
      <div class="bg-blue-50 p-4 mb-4">
        <p class="text-xs font-bold text-gray-800 mb-2">{{ t('labels.howToUse') }}</p>
        <ol class="text-xs text-gray-600 space-y-1.5 list-decimal list-inside">
          <li>{{ t('labels.pairStep1') }}</li>
          <li>{{ t('labels.pairStep2') }}</li>
          <li>{{ t('labels.pairStep3') }}</li>
          <li>{{ t('labels.pairStep4') }}</li>
        </ol>
        <p class="text-xs text-gray-500 mt-2">{{ t('labels.pairNoLogin') }}</p>
      </div>

      <div class="flex items-center justify-center gap-2 text-amber-600">
        <svg class="w-4 h-4 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd" />
        </svg>
        <span class="text-sm font-medium">{{ t('labels.waitingConnect') }}</span>
      </div>
    </div>
  </div>

  <div *ngIf="loading || printing" class="text-center bg-gray-100 mb-4 sm:mb-8 p-2 sm:p-4">
    <h2 *ngIf="loading" class="text-sm sm:text-base md:text-lg text-red-400 font-bold">{{ t('labels.fetchingData') }}</h2>
    <h2 *ngIf="printing" class="text-sm sm:text-base md:text-lg text-red-400 font-bold">{{ t('labels.sendingPrint') }}</h2>
  </div>

  <!-- Log de Etiquetas Impressas -->
  <div #logsContainer class="flex-grow overflow-auto border p-2 sm:p-4" style="max-height: calc(100vh - 280px);" (scroll)="onScroll($event)">
    <h6 class="text-base sm:text-lg font-medium mb-3 sm:mb-4 text-center">{{ t('labels.sentToPrinter') }}</h6>

    <!-- Tabela para desktop -->
    <div class="hidden md:block overflow-x-auto">
      <table class="min-w-full border-collapse">
        <thead>
          <tr class="bg-gray-100">
            <th class="border border-gray-300 p-2 text-gray-600 font-bold text-center w-16">#</th>
            <th class="border border-gray-300 p-2 text-gray-600 font-bold text-left">{{ t('labels.saleNumber') }}</th>
            <th class="border border-gray-300 p-2 text-gray-600 font-bold text-left">{{ t('labels.action') }}</th>
            <th class="border border-gray-300 p-2 text-gray-600 font-bold text-left">{{ t('labels.dateTime') }}</th>
            <th class="border border-gray-300 p-2 text-gray-600 font-bold text-left">{{ t('labels.observation') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of logs" [ngClass]="log.lineColor" class="border-b border-gray-300 hover:bg-gray-50">
            <td class="border border-gray-300 p-2 text-center">{{ log.sequential }}</td>
            <td class="border border-gray-300 p-2 text-left">
              <a [href]="'https://www.mercadolivre.com.br/vendas/'+log.orderId +'/detalhe'" target="_blank"
                 [title]="t('labels.viewOnMl')" [ngClass]="log.lineColor" class="hover:underline break-all">{{ log.orderId }}</a>
            </td>
            <td class="border border-gray-300 p-2 text-left">
              <a *ngIf="log.errorCode == 21" href="#"
                (click)="invoiceOrder(log.orderId, log.sequential);$event.preventDefault()"
                [ngClass]="log.lineColor" class="hover:underline"
                [class.pointer-events-none]="rowActionsDisabled"
                [class.opacity-50]="rowActionsDisabled">{{ t('labels.clickToIssue') }}</a>
              <a *ngIf="log.errorCode != 21 && log.error" href="#"
                (click)="reprint(log.orderId);$event.preventDefault()"
                [title]="t('labels.reprintHint')" [ngClass]="log.lineColor" class="hover:underline"
                [class.pointer-events-none]="rowActionsDisabled"
                [class.opacity-50]="rowActionsDisabled">{{ t('labels.reprint') }}</a>
              <span *ngIf="log.errorCode != 21 && !log.error">N/A</span>
            </td>
            <td class="border border-gray-300 p-2 text-left whitespace-nowrap">{{ log.dateTime | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="border border-gray-300 p-2 text-left break-words">{{ log.observation }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Cards para mobile -->
    <div class="md:hidden space-y-3">
      <div *ngFor="let log of logs" [ngClass]="log.lineColor" class="border border-gray-300 p-3 bg-white">
        <div class="flex justify-between items-start mb-2">
          <span class="font-bold text-gray-600">#{{ log.sequential }}</span>
          <span class="text-xs text-gray-500">{{ log.dateTime | date:'dd/MM/yyyy HH:mm' }}</span>
        </div>
        <div class="mb-2">
          <span class="text-xs text-gray-500 block mb-1">{{ t('labels.saleNumber') }}:</span>
          <a [href]="'https://www.mercadolivre.com.br/vendas/'+log.orderId +'/detalhe'" target="_blank"
             [title]="t('labels.viewOnMl')" [ngClass]="log.lineColor" class="hover:underline break-all text-sm font-medium">{{ log.orderId }}</a>
        </div>
        <div class="mb-2" *ngIf="log.errorCode == 21">
          <span class="text-xs text-gray-500 block mb-1">{{ t('labels.action') }}:</span>
          <a href="#" (click)="invoiceOrder(log.orderId, log.sequential);$event.preventDefault()"
            [ngClass]="log.lineColor" class="hover:underline text-sm"
            [class.pointer-events-none]="rowActionsDisabled"
            [class.opacity-50]="rowActionsDisabled">{{ t('labels.clickToIssue') }}</a>
        </div>
        <div class="mb-2" *ngIf="log.errorCode != 21 && log.error">
          <span class="text-xs text-gray-500 block mb-1">{{ t('labels.action') }}:</span>
          <a href="#" (click)="reprint(log.orderId);$event.preventDefault()"
            [title]="t('labels.reprintHint')" [ngClass]="log.lineColor" class="hover:underline text-sm"
            [class.pointer-events-none]="rowActionsDisabled"
            [class.opacity-50]="rowActionsDisabled">{{ t('labels.reprint') }}</a>
        </div>
        <div>
          <span class="text-xs text-gray-500 block mb-1">{{ t('labels.observation') }}:</span>
          <span class="text-sm break-words">{{ log.observation }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="loadingLogs" class="text-center py-4">
      <span class="text-gray-500 text-sm sm:text-base">{{ t('labels.loadingMoreLogs') }}</span>
    </div>
  </div>
</div>
